import { Box } from "@mui/material";
import { ArrayField, Datagrid, FunctionField, TextField, useRecordContext } from "react-admin";
import { settings } from "app";
import { MoneyField } from "server/components/Fields/MoneyField";
import { DebtStatusChoices } from "utils/choices";
import StatusChip from "../../Partials/StatusChip";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const DebtStatusColorMap = {
  0: "warning",
  1: "success",
  2: "default",
};

const DebtsSection = () => {
  const record = useRecordContext();
  const debts = record?.debts ?? [];

  if (debts.length === 0) return <em>Няма данни</em>;

  return (
    <Box>
      <ArrayField source="debts">
        <Datagrid bulkActionButtons={false} rowClick={false} sx={settings.style.secondaryDatagrid}>
          <FunctionField label="Година" render={r => r.year ?? "—"} />
          <TextField source="typeNameBg" label="За какво" />
          <MoneyField source="amount" label="Сума" />
          <FunctionField
            label="Статус"
            render={r => (
              <StatusChip status={r.status} choices={DebtStatusChoices} colorMap={DebtStatusColorMap} />
            )}
          />
          <DoctoralDateField source="paidOn" label="Платено на" />
          <DoctoralDateField source="createdOn" label="Създадено на" />
        </Datagrid>
      </ArrayField>
    </Box>
  );
};

export default DebtsSection;
